import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { siteConfig } from '../data/siteConfig';
type BuyButtonProps = {
  label: string;
  href?: string;
  fullWidth?: boolean;
};
export function BuyButton({
  label,
  href = siteConfig.checkoutUrl,
  fullWidth = false
}: BuyButtonProps) {
  return <a href={href} className={`group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-cta px-6 py-4 font-display text-[15px] font-extrabold tracking-wide text-cta-ink shadow-[0_6px_0_0_#D97820] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-cta-hover active:translate-y-[3px] active:shadow-[0_3px_0_0_#D97820] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:px-8 sm:text-base ${fullWidth ? 'w-full' : ''}`} data-id="element-25" data-mp="2obna4ilmpiz1">
      {label}
      <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-26" data-mp="8laf0hgi2o4p" />
    </a>;
}